<section class="service-banner overflow-hidden">
	<div class="container">
		<!-- <img class="img-globe floatimg" src="{{baseUrl}}/img/home/service-image.png" alt="Web Development Services" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="150"> -->
		<!-- <canvas id="canvas" class="img-globe floatimg"></canvas> -->
		<div class="row">
			<div
				class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			>
				<!-- <img class="img-globe floatimg" src="{{baseUrl}}/img/3D-images/services.png" alt="Branding Services" width="" height="" loading="lazy" > -->
				<div id="spline-container">
					<!-- <canvas id="canvas" class="floatimg"></canvas> -->
					<!-- <div
						#canvas
						style="width: 100%; height: 100%"
						class="img-globe"
					></div> -->
					<!-- <div #canvas style="width: 100%; height: 100%" class="floatimg"></div> -->
					<spline-viewer
						class="floatimg"
						url="https://prod.spline.design/ETc1NgtkFiSuPoFT/scene.splinecode"
					></spline-viewer>
				</div>

				<!-- old code -->
				<!-- <div class="vh-100">
					<div
						class="d-flex flex-column justify-content-center align-items-start h-100"
					>
						<div class="block-content">
							<div class="text-center position-absolute w-100 start-0  end-0">
              <img src="../../assets/img/services/white.svg" alt="Design Services" class="">
            </div>
							<div class="d-flex flex-row w-100">
								<h2
									class="d-none d-sm-block d-md-block d-lg-block d-xl-block d-xxl-block textcolor2 size90"
									data-aos="fade-up"
									data-aos-duration="1000"
									data-aos-delay="100"
								>
									We don't do
								</h2>
								<h2
									class="d-flex d-sm-none d-md-none d-lg-none d-xl-none d-xxl-none align-items-end size90 textcolor2"
									data-aos="fade-up"
									data-aos-duration="1000"
									data-aos-delay="100"
								>
									We don't do
								</h2>
								<div id="lottie"></div>
							</div>
							mobile
							<h2 class="d-block d-sm-none d-md-none d-lg-none d-xl-none d-xxl-none text-white" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100"> one</h2>
							<h2
								class="csm d-block d-sm-none d-md-none d-lg-none d-xl-none d-xxl-none text-white size90"
								data-aos="fade-up"
								data-aos-duration="1000"
								data-aos-delay="200"
							>
								one size fits all
							</h2>
							mobile
							<h2
								class="csm d-none d-sm-block d-md-block d-lg-block d-xl-block d-xxl-block text-white size90"
								data-aos="fade-up"
								data-aos-duration="1000"
								data-aos-delay="200"
							>
								one size fits all
							</h2>
						</div>
					</div>
					<p class="p32 head position-relative w-100 start-0  end-0 d-block d-sm-none d-md-none d-lg-none d-xl-none d-xxl-none" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100"> We do it real </p>
				</div> -->

				<div class="vh-100">
					<div
						class="d-flex flex-column justify-content-center align-items-start h-100"
					>
						<h1
							class="textcolor2 size90 contentbl"
							data-aos="fade-up"
							data-aos-duration="1000"
							data-aos-delay="200"
						>
							<span class="d-flex align-items-end">
								<span> We don't do </span>
								<span id="lottie"></span>
							</span>
							<span class="text-white size90 d-block">one size fits all </span>
						</h1>
					</div>
				</div>
				<div class="position-absolute banner-left-content content-left">
					<ul
						class="d-flex flex-column justify-contente-arround p-0 float-start"
						data-aos="fade-up"
						data-aos-duration="1000"
						data-aos-delay="200"
						style="
							height: 130px;
							list-style: none;
							justify-content: space-between;
						"
					>
						<li>
							<a
								class=""
								href="https://www.instagram.com/pixtar.ae/"
								target="_blank"
							>
								<img
									src="{{ baseUrl }}/img/home/social-media/instagram-white.svg"
									alt="Graphic design Services"
									width="15"
									height=""
									loading="lazy"
								/>
							</a>
						</li>
						<li>
							<a
								class=""
								href="https://www.facebook.com/pixtar.ae/"
								target="_blank"
							>
								<img
									src="{{ baseUrl }}/img/home/social-media/facebook-white.svg"
									alt="ecommerce web development Services"
									width="10"
									height=""
									loading="lazy"
								/>
							</a>
						</li>
						<li>
							<a
								class=""
								href="https://www.linkedin.com/company/pixtar-ae/"
								target="_blank"
							>
								<img
									src="{{ baseUrl }}/img/home/social-media/linkedin-white.svg"
									alt="Luxury web design services"
									width="15"
									height=""
									loading="lazy"
								/>
							</a>
						</li>
						<li>
							<a
								class="whatsapp-icon2 slideUpReturn tabmob"
								href="https://wa.me/+971527930781"
								target="_blank"
							>
								<img
									src="{{ baseUrl }}/img/home/whatsapp-white.svg"
									alt="logo designing service"
									width="18"
									height=""
									loading="lazy"
								/>
							</a>
						</li>
					</ul>
					<div
						class="d-flex flex-column justify-contente-center left-content2"
						data-aos="fade-up"
						data-aos-duration="1000"
						data-aos-delay="200"
					>
						<p class="text-white lufgaregular">Our services are tailored to</p>
						<p class="text-white lufgaregular">the needs of your brand.</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<!-- banner content ends-->
<!-- our clients-->
<section class="featuredvideo m80 bannerbgcolor">
	<div class="container">
		<div
			class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			data-aos="fade-up"
			data-aos-duration="1000"
			data-aos-delay="100"
		>
			<div class="blocklist section1">
				<h2 class="fontsize12 text-white semibold mb-4 text-uppercase">
					OUR CLIENTS INCLUDE…
				</h2>
				<div class="row">
					<ng-container>
						<div class="col-md-12">
							<div class="row">
								<!-- *ngFor="let data of allmight" -->
								<div
									class="col custom-col mb-lg-5 mb-md-4 mb-4"
									*ngFor="let image of filteredClients; let i = index"
								>
									<a href="/">
										<!-- <img src="{{image.img}}" alt="Design Services" class="img-fluid {{image.class}}">  -->
										<img
											src="{{ image.img }}"
											alt="Luxury branding services for premium brands"
											class="img-fluid"
											data-aos="zoom-in"
											data-aos-duration="1500"
											data-aos-delay="50"
											width=""
											height=""
											loading="lazy"
										/>
									</a>
								</div>
							</div>
							<!-- </div> -->
						</div>
					</ng-container>
				</div>
			</div>
		</div>
	</div>
</section>
<!-- our clients-->
<!--First service starts-->
<section id="services1" class="services mtrem8 mbrem8" data-scroll-nav="0">
	<div class="container">
		<div class="row">
			<div
				class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			>
				<div class="row">
					<div
						class="col-xl-6 col-lg-6 col-md-6 order-sm-1 order-1"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<div class="img-block">
							<img
								src="{{ baseUrl }}/img/services/branding.jpg"
								alt="Branding Services Dubai"
								class="w-100"
								width=""
								height=""
								loading="lazy"
							/>
						</div>
					</div>
					<div
						class="col-xl-5 col-lg-5 mx-auto col-md-6 order-sm-2 order-2"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<div class="d-flex flex-column h-100 service-content">
							<div>
								<h3 class="fontsize12 semibold m-0 bl mt-3 mt-md-0">
									Our Services
								</h3>
								<h2 class="size53 bold mb-1 textcolor1">Premium Branding</h2>
								<p class="size20 medium">
									Your Brand, Your Story, Perfectly Told
								</p>
							</div>
							<p class="size18 textcolor3 serwidth">
								Your brand is more than a logo—it’s a promise. With designs
								built on the timeless principles of the golden ratio, we help
								businesses create a story that feels both balanced and bold.
							</p>
							<div class="points">
								<p class="fontsize12 mb-0">
									<span class="lufgabold fontsize12">
										DESIGNING AND CONCEPTUALISING: </span
									><span class="lufgamedium fontsize12">
										Custom Logo | Brand Guidelines | Brand Aesthetics | Luxury
										Packaging</span
									>
								</p>
								<!-- <p>Identity | Brandbook & more…</p> -->
							</div>
							<!-- <p (click)="navigateToLink('branding')" class="link">Let us <span class="barcelony">listen</span> to your story</p> -->
							<!-- <div class="position-relative">
								<div class="float-start cwd243">
									<p>
										<a
											href="/services/branding#packages"
											class="cstbtn cstbtn128"
											(click)="navigateToLink('branding')"
										>
											<span class="text text128 semibold"
												>Explore Branding Packages</span
											>
											<span class="borderspan"
												><i class="fa fa-chevron-right" aria-hidden="true"></i>
											</span>
										</a>
									</p>
								</div>
							</div> -->
							<div class="linkToPackages">
								<a
									href="/services/branding#packages"
									(click)="navigateToLink('branding')"
									class="d-flex justify-content-start align-items-center"
								>
									<span class="text semibold text-capitalize">
										Explore Branding Packages
									</span>
									<!--<i class="fa fa-chevron-right" aria-hidden="true"></i> -->
									<lucide-icon
										name="chevron-right"
										class="lucide-arrow-icon"
									></lucide-icon>
									<span class="borderspan"> </span>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<!--First service ends-->
<!--Second service starts-->
<section id="services2" class="services mtrem8 mbrem8" data-scroll-nav="1">
	<div class="container">
		<div class="row">
			<div
				class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			>
				<div class="row">
					<div
						class="col-xl-5 col-lg-5 mx-auto col-md-6 order-md-1 order-sm-2 order-2"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<div
							class="d-flex flex-column justify-content-between h-100 service-content ps-md-0 ps-sm-auto ps-auto"
						>
							<div>
								<h3 class="fontsize12 semibold m-0 bl mt-3 mt-md-0">
									Our Services
								</h3>
								<h2 class="size53 bold mb-1 textcolor1">
									High-End Graphic Design
								</h2>
								<p class="size20 medium">
									Designs That Perform On Every Screen
								</p>
							</div>
							<p class="size18 textcolor3 serwidth">
								Need fresh designs every month? Our subscription plan gives you
								creative power on demand—because good design should always be
								within reach.
							</p>
							<!-- <div>
								<h2 class="fontsize12 semibold m-0 bl">
									High-End Graphic Design
								</h2> -->
							<!-- <p class="size18">Designs That Perform On Every Screen</p> -->
							<!-- </div> -->
							<!-- <p class="size18 textcolor3 serwidth">
								WNeed fresh designs every month? Our subscription plan gives you
								creative power on demand—because good design should always be
								within reach.
							</p> -->
							<div class="points">
								<p class="fontsize12 mb-0">
									<span class="lufgabold fontsize12"> DESIGNING:</span
									><span class="lufgamedium fontsize12">
										Catalog | Company Profile | Pitch-deck | Social Media Theme
										| Event Theme | Marketing Materials</span
									>
								</p>
								<!-- <p>Identity | Brandbook & more…</p> -->
							</div>
							<!-- <p (click)="navigateToLink('branding')" class="link">Let us <span class="barcelony">listen</span> to your story</p> -->
							<!-- <div class="position-relative">
								<div class="float-start cwd243 cwd2432">
									<p>
										<a
											href="/services/graphics#packages"
											class="cstbtn cstbtn128"
											(click)="navigateToLink('graphics')"
										>
											<span class="text text128 semibold"
												>Explore Graphics Plans</span
											>
											<span class="borderspan"
												><i class="fa fa-chevron-right" aria-hidden="true"></i>
											</span>
										</a>
									</p>
								</div>
							</div> -->

							<div class="linkToPackages">
								<a
									href="/services/graphics#packages"
									(click)="navigateToLink('graphics')"
									class="d-flex justify-content-start align-items-center"
								>
									<span class="text semibold text-capitalize">
										Explore Graphics Plans
									</span>
									<!--<i class="fa fa-chevron-right" aria-hidden="true"></i> -->
									<lucide-icon
										name="chevron-right"
										class="lucide-arrow-icon"
									></lucide-icon>
									<span class="borderspan"> </span>
								</a>
							</div>
						</div>
					</div>
					<div
						class="col-xl-6 col-lg-6 col-md-6 offset-xl-1 offset-lg-1 order-md-2 order-sm-1 order-1"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<div class="img-block">
							<img
								src="{{ baseUrl }}/img/services/graphic-1.jpg"
								alt="Best graphic Design services Dubai"
								width=""
								height=""
								loading="lazy"
								class="w-100"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="mask">
		<img
			src="{{ baseUrl }}/img/home/mask2.svg"
			alt="Best web development service provider"
			width=""
			height=""
			loading="lazy"
		/>
	</div>
</section>
<!--<p (click)="navigateToLink('website')" class="link">Let's <span class="barcelony">tell</span> your story</p> Second service ends-->

<!--third service starts-->
<section id="services3" class="services mtrem8 mbrem8" data-scroll-nav="2">
	<div class="container">
		<div class="row">
			<div
				class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			>
				<div class="row">
					<div
						class="col-xl-6 col-lg-6 col-md-6 order-sm-1 order-1"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<div class="img-block">
							<img
								src="{{ baseUrl }}/img/services/impactfull.jpg"
								alt="logo design services Dubai"
								width=""
								height=""
								loading="lazy"
								class="w-100"
							/>
						</div>
					</div>
					<div
						class="col-xl-5 col-lg-5 mx-auto col-md-6 order-sm-2 order-2"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<div
							class="d-flex flex-column justify-content-between h-100 service-content"
						>
							<div>
								<h3 class="fontsize12 semibold m-0 bl mt-3 mt-md-0">
									Our Services
								</h3>
								<h2 class="size53 bold mb-1 textcolor1">
									Highly-Impactful Website
								</h2>
								<p class="size20 medium">
									Designs That Perform On Every Screen
								</p>
							</div>
							<p class="size18 textcolor3 serwidth">
								We don’t build websites; we create experiences. Our custom-built
								websites are fast, functional, and perfectly aligned with your
								audience and business goals —because we don’t believe in
								templates.
							</p>

							<!-- <div>
								<h2 class="size32 mb-1">Highly-Impactful Website</h2>
								<p class="size18">Designs That Perform On Every Screen</p>
							</div>
							<p class="size18 textcolor3 serwidth">
								We don’t build websites; we create experiences. Our custom-built
								websites are fast, functional, and perfectly aligned with your
								audience and business goals —because we don’t believe in
								templates.
							</p> -->
							<div class="points">
								<p class="fontsize12 mb-0">
									<span class="lufgabold fontsize12"
										>DESIGN AND DEVELOPMENT:</span
									><span class="lufgamedium fontsize12">
										Static Website | Dynamic Website | Api Integration
									</span>
								</p>
								<!-- <p>Identity | Brandbook & more…</p> -->
							</div>
							<!-- <p (click)="navigateToLink('branding')" class="link">Let us <span class="barcelony">listen</span> to your story</p> -->
							<!-- <div class="position-relative">
								<div class="float-start cwd243 cwd2433">
									<p>
										<a
											href="/services/website#packages"
											class="cstbtn cstbtn128"
											(click)="navigateToLink('website')"
										>
											<span class="text text128 semibold"
												>Explore Website Service</span
											>
											<span class="borderspan">
												<i class="fa fa-chevron-right" aria-hidden="true"></i>
											</span>
										</a>
									</p>
								</div>
							</div> -->

							<div class="linkToPackages">
								<a
									href="/services/website#packages"
									(click)="navigateToLink('website')"
									class="d-flex justify-content-start align-items-center"
								>
									<span class="text semibold text-capitalize">
										Explore Website Service
									</span>
									<!--<i class="fa fa-chevron-right" aria-hidden="true"></i> -->
									<lucide-icon
										name="chevron-right"
										class="lucide-arrow-icon"
									></lucide-icon>
									<span class="borderspan"> </span>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<!--third service ends-->

<!--fourth service starts-->
<section id="services4" class="services mtrem8 mbrem8" data-scroll-nav="3">
	<div class="container">
		<div class="row">
			<div
				class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			>
				<div class="row">
					<div
						class="col-xl-5 col-lg-5 mx-auto col-md-6 order-md-1 order-sm-2 order-2"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<div
							class="d-flex flex-column justify-content-between h-100 service-content ps-md-0 ps-sm-auto ps-auto"
						>
							<div>
								<h3 class="fontsize12 semibold m-0 bl mt-3 mt-md-0">
									Our Services
								</h3>
								<h2 class="size53 bold mb-1 textcolor1">
									Highly-Converting Ecommerce Website
								</h2>
								<p class="size20 medium">
									Sell Globally With Custom Ecommerce Solutions
								</p>
							</div>
							<p class="size18 textcolor3 serwidth">
								A beautiful online store isn’t enough—you need one that
								converts. Whether it’s Magento, Shopify, or Node.js, we create
								custom eCommerce platforms that perform, scale, and grow with
								you.
							</p>
							<!-- <div>
								<h2 class="size32">Highly-Converting Ecommerce Website</h2>
								<p class="size18">
									Sell Globally With Custom Ecommerce Solutions
								</p>
							</div>
							<p class="size18 textcolor3 serwidth">
								A beautiful online store isn’t enough—you need one that
								converts. Whether it’s Magento, Shopify, or Node.js, we create
								custom eCommerce platforms that perform, scale, and grow with
								you.
							</p> -->
							<div class="points">
								<p class="fontsize12 mb-0">
									<span class="lufgabold fontsize12">
										DESIGNING AND DEVELOPMENT:
									</span>
									<span class="lufgamedium fontsize12">
										Shopify | Custom Magento 2.0+ | Custom eCommerce website on
										NodeJS & Angular
									</span>
								</p>
								<!-- <p>Identity | Brandbook & more…</p> -->
							</div>
							<!-- <p (click)="navigateToLink('branding')" class="link">Let us <span class="barcelony">listen</span> to your story</p> -->
							<!-- <div class="position-relative">
								<div class="float-start cwd243 cwd2434">
									<p>
										<a
											href="/services/ecommerce-web-development#packages"
											class="cstbtn cstbtn128"
											(click)="navigateToLink('ecommerce')"
										>
											<span class="text text128 semibold">
												Explore E-Commerce Solutions
											</span>
											<span class="borderspan">
												<i class="fa fa-chevron-right" aria-hidden="true"></i
											></span>
										</a>
									</p>
								</div>
							</div> -->
							<div class="linkToPackages">
								<a
									href="/services/ecommerce-web-development#packages"
									(click)="navigateToLink('ecommerce')"
									class="d-flex justify-content-start align-items-center"
								>
									<span class="text semibold text-capitalize">
										Explore E-Commerce Solutions
									</span>
									<!--<i class="fa fa-chevron-right" aria-hidden="true"></i> -->
									<lucide-icon
										name="chevron-right"
										class="lucide-arrow-icon"
									></lucide-icon>
									<span class="borderspan"> </span>
								</a>
							</div>
						</div>
					</div>
					<div
						class="col-xl-6 col-lg-6 col-md-6 offset-xl-1 offset-lg-1 order-md-2 order-sm-1 order-1"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<div class="img-block">
							<img
								src="{{ baseUrl }}/img/services/ecommerce.jpg"
								alt="custom ecommerce services Dubai"
								width=""
								height=""
								loading="lazy"
								class="w-100"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<!--fourth service ends-->
<!-- Successful story sections-->

<app-testimonial></app-testimonial>
<!-- Successful story sections-->

<!-- Faq section Starts -->
<!-- <section class="section faqsection backeeedf0">
	<div class="mask">
		<img src="{{baseUrl}}/img/home/mask-transparent.svg" alt="Professional graphic design services for branding">
	</div>
	<div class="container">
		<div class="row">
			<div class="col-md-10 col-sm-11 col-11 m-auto">
				<div class="row">
					<div class="col-lg-4 col-md-6 col-sm-6" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100">
						<div class="creative">
							<h2 class="textcolor1">
								What <br /> makes Pixtar <br /> Special? <br /> <span> And other FAQs… </span>
							</h2>
						</div>
					</div>
					<div class="col-lg-7 offset-lg-1 col-md-6 col-sm-6" data-aos="fade-up" data-aos-duration="1000"
						data-aos-delay="100">
						<div class="d-block ">
							<div class="custom-collapse footer-collapse">
								<div class="accordion" id="accordionExample1">
									<div class="accordion-item brdtp">
										<h3 class="accordion-header" id="headingOne">
											<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
												data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
												Alright, no secrets – what makes Pixtar stand out?
											</button>
										</h3>
										<div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne"
											data-bs-parent="#accordionExample1">

											<div class="accordion-body">
												Pixtar stands out for our unique blend of creativity, strategy, and a deep commitment to client
												satisfaction. We don’t just design; we craft memorable, user-friendly experiences that make
												brands shine.
											</div>
										</div>
									</div>

									<div class="accordion-item">
										<h3 class="accordion-header" id="headingThree">
											<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
												data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
												Where are you based?
											</button>
										</h3>
										<div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingThree"
											data-bs-parent="#accordionExample1">
											<div class="accordion-body">
												Virtually, next door! We’re proudly based in Dubai, UAE, but our team collaborates with clients
												worldwide, making distance no barrier to outstanding design!

												Our business hours are 9 am–6 pm GST / 1 am–10 am EST / 10 pm–7 am PST. But with our
												early-rising CEO and night-owl CTO, we’re always able to sync up with clients from LA all the
												way to Australia—and all the lovely places in between.
											</div>
										</div>
									</div>

									<div class="accordion-item">
										<h3 class="accordion-header" id="headingFour">
											<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
												data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
												How are you different from a freelance designer?
											</button>
										</h3>
										<div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
											data-bs-parent="#accordionExample1">
											<div class="accordion-body">
												At Pixtar, you get the expertise of an entire team, not just one individual. We bring together
												specialized skills in design, strategy, and development, providing a more comprehensive approach
												and smoother project delivery.
											</div>
										</div>
									</div>

									<div class="accordion-item">
										<h3 class="accordion-header" id="headingSix">
											<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
												data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
												What other design magic do you offer?
											</button>
										</h3>
										<div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingThree"
											data-bs-parent="#accordionExample1">
											<div class="accordion-body">
												Besides website design, we specialize in branding, UI/UX design, graphic design, and digital
												marketing assets. Whatever your design needs, Pixtar has the creative solution.
											</div>
										</div>
									</div>

									<div class="accordion-item">
										<h3 class="accordion-header" id="headingSix">
											<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
												data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
												Who do you usually work with?
											</button>
										</h3>
										<div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingThree"
											data-bs-parent="#accordionExample1">
											<div class="accordion-body">
												We collaborate with businesses of all sizes—from startups to established brands—across a range
												of industries, including Lifestyle, healthcare, technology, real estate, and more.
											</div>
										</div>
									</div>
									<div class="accordion-item">
										<h3 class="accordion-header" id="headingSix">
											<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
												data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
												Which platforms do you use for building websites?
											</button>
										</h3>
										<div id="collapseSix" class="accordion-collapse collapse" aria-labelledby="headingThree"
											data-bs-parent="#accordionExample1">
											<div class="accordion-body">
												We work with popular platforms like Angular, Node.js, React, Shopify, Magento and Webflow,
												ensuring you get a website that’s not only beautiful but also easy to manage and scalable.
											</div>
										</div>
									</div>
									<div class="accordion-item">
										<h3 class="accordion-header" id="headingSix">
											<button class="accordion-button collapsed brdbtm" type="button" data-bs-toggle="collapse"
												data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
												I’m in! When can we get started?
											</button>
										</h3>
										<div id="collapseSeven" class="accordion-collapse collapse" aria-labelledby="headingThree"
											data-bs-parent="#accordionExample1">
											<div class="accordion-body">
												We’re thrilled to have you onboard! Just reach out through our contact page, and we’ll set up a
												kickoff meeting to dive into your project.
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

</section> -->
<!-- <app-faq-component bannerClass="backeeedf0" h1text="textcolor1" [isWhiteText]="false" ></app-faq-component> -->
<app-faq-component></app-faq-component>
<!-- Faq section ends -->
